export default {
    title: '立即訂購'
}
